export default {"src":"/_next/static/media/Icon.4dc3d6f1.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};